module.exports = __webpack_public_path__ + "img/v4_h6.4bab0f3b.png";